import { LoadingButton } from '@mui/lab';
import {
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    Typography,
    Alert,
    FormControl,
    TextField
} from '@mui/material';
import { FC, useState } from 'react';
import { toast } from 'react-toastify';
import CloseIcon from '@mui/icons-material/Close';
import { EditIcon } from '../../../vectors/index';
import Done from '@mui/icons-material/Done';
import { useUpdateEmployerUrl } from '../hooks/useUpdateEmployerUrl';
import { Employer } from '../types';
import { getStrippedText } from '@utils/helper';

type EmployerEditUrlProps = {
    handleClose: () => void;
    item: Employer;
};

const EmployerEditUrl: FC<EmployerEditUrlProps> = ({
    handleClose,
    item,
}) => {
    const [errorText, setErrorText] = useState<string>('');
    const [url, setUrl] = useState('');

    const { updateUrl, isUpdateUrlLoading } = useUpdateEmployerUrl({ setErrorText })

    const handleDelete = () => {
        const options = {
            onSuccess: (data: { message: string, status: number }) => {
                if(data.status === 200){
                    toast.success(data.message)
                    handleClose();
                }
            },
        };

        updateUrl({
            company_id: item.company ? item.company.id : item.enterprise ? item.enterprise?.id : '',
            is_enterprise: item.enterprise ? true : false,
            url
        }, options)
    }

    return (
        <Dialog
            open
            onClose={handleClose}
            maxWidth="xs"
            fullWidth
        >
            <DialogTitle>
                <IconButton sx={{ position: 'absolute', top: 5, right: 5 }} onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
                <br />
                <EditIcon />
                <br />
                <Typography variant="h6" >
                    Edit Url
                </Typography>
            </DialogTitle>
            <DialogContent>
                {errorText && <Alert sx={{ margin: "10px 0" }} severity="error">{errorText}</Alert>}
                <Typography variant="body1"
                    m={2}
                    sx={{ fontSize: "18px", textAlign: "center" }}
                >Current Url: <b>/{item.company ? item?.company.s_slug : item.enterprise && item?.enterprise.s_slug}</b></Typography>
                <FormControl sx={{ marginBottom: "10px" }} fullWidth>
                    <Typography id="pay-rate-type-label">New Url</Typography>
                    <TextField
                        variant="outlined"
                        value={url}
                        onChange={(e) => {
                            const input = e.target.value;
                            const slug = input
                                .toLowerCase()
                                .replace(/[^a-z0-9-]/g, '')
                                .replace(/-+/g, '-')

                            setUrl(slug);
                        }}
                        fullWidth
                        size="small"
                    />

                </FormControl>
                <LoadingButton
                    loading={isUpdateUrlLoading}
                    disabled={isUpdateUrlLoading || getStrippedText(url).length <= 2 || !url}
                    fullWidth
                    startIcon={<Done />}
                     sx={{marginTop:2, marginBottom:2}}
                    variant="contained" color="primary" onClick={handleDelete}>
                    Update
                </LoadingButton>
            </DialogContent>
        </Dialog>
    );
};

export default EmployerEditUrl;
